import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import LoginHistoryLayer from "../../../components/Admin/LoginHistoryLayer";

const LoginHistory = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <LoginHistoryLayer />
      </MasterLayout>
    </>
  );
};
export default LoginHistory